//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    "searchType", //查询类型
    "filterJson", //筛选选项列表
    "jsonName", //复选框列表json名 同时控制整体是否显示
    "filterLoading", //加载。。
    "modelWidth", //弹框宽度
    "title_name", //标题
    "ascName", //正序名称
    "descName", //倒序名称
    "pd_name", //输入框默认提示placeholder 并 控制输入框显示
    "orderName", //排序关键词 同时控制是否显示排序
    "crrSortName", //当前排序值
    "crrOrderName", //当前排序参数名
    "filterWhere", //筛选已选json
    "pamName", //选中值json参数名
    "isSearch"
  ],
  data() {
    return {
      filterShow: false, //弹框显示
      keyNum: 1,
      crrSelect: [],
      filterText: "",
      filterServiceText: "",
      crrFilterJson: [],
      isCheckAllApplicant: false, // 申请人全选
    };
  },
  watch: {
    filterWhere() {
      console.log(45487)
      this.crrSelect = this.filterWhere[this.pamName];
    },
    isSearch() {
      if (
        this.isSearch &&
        this.searchType == "4" &&
        this.jsonName == "applicantFilter"
      ) {
        //申请人 高亮1-2秒
        setTimeout(() => {
          let dom = document.getElementById(this.jsonName); //使用的传参的pamName作为id
          dom.style.color = "#fda14d";
          if (!this.filterWhere.proposerInfo.length) {
            setTimeout(() => {
              dom.style.color = "#333";
            }, 2000);
          }
        }, 1000);
      }
    },
    filterJson() {
      this.crrFilterJson = this.filterJson;
    }
  },
  mounted() {},
  methods: {
    showModel() {
      if (this.jsonName != "codeFilter" && this.jsonName != "goodsFilter") {
        if (!this.filterJson.length) {
          this.$emit("getSearchFilter", this.jsonName);
        }
        this.filterText = "";
        this.crrFilterJson = this.filterJson;
      }
      this.filterServiceText = "";
    },
    addressHide(name, str) {
      const strLength = str.length;
      const nameLength = name ? name.length : 0;
      if (strLength + nameLength > 45) {
        let satrt = str.substring(0, 45 - nameLength - 5);
        let end = str.substring(strLength - 5, strLength);
        return satrt + "..." + end;
      } else {
        return str;
      }
    },
    cancelModel() {
      this.filterShow = false;
      this.crrSelect = this.filterWhere[this.pamName];
      if(this.jsonName === 'applicantFilter'){
        this.isCheckAllApplicant = this.crrSelect.length === this.crrFilterJson.length
      }
    },
    filterListSort(sort) {
      this.filterShow = false;
      this.$emit("filterListSort", this.orderName, sort);
    },
    // 表头过滤- 弹框-搜索
    searchFilter(e) {
      this.fliterInfoByText(e.target.value);
    },
    // 表头过滤- 弹框- 服务端搜索
    filterService() {
      if (this.pamName == "trademarkName") {
        this.$emit("getSearchFilter", this.jsonName, this.filterServiceText);
      } else {
        let arr = [];
        if (this.filterServiceText) {
          if (this.pamName == "code") {
            //商标号多个
            arr = this.filterServiceText.split(/,|，|\s+/);
          } else if (this.pamName == "goods") {
            arr = [this.filterServiceText];
          }
        }
        let data = this.filterWhere;
        data[this.pamName] = arr;
        this.$emit("update:filterWhere", data);
        this.$emit("filterConfirm", this.pamName);
        this.filterShow = false;
        console.log(this.filterWhere);
      }
    },
    fliterInfoByText(text) {
      if (text) {
        this.crrFilterJson = this.filterJson.filter(
          item => (item.headerName + item.headerGrayName).indexOf(text) > -1
        );
      } else {
        this.crrFilterJson = this.filterJson;
      }
    },
    filterConfirm() {
      if (this.pamName && !this.crrSelect.length) {
        this.$message("请勾选要筛选的数据");
      } else {
        let data = this.filterWhere;
        data[this.pamName] = this.crrSelect;
        this.$emit("update:filterWhere", data);
        this.$emit("filterConfirm", this.pamName);
        this.filterShow = false;
      }
    },
    resetConfirm() {
      //从服务端搜索的 搜索空则为重置
      if (
        this.pamName == "code" ||
        this.pamName == "goods"
      ) {
        this.filterServiceText = "";
        this.filterService();
      } else {
        this.crrSelect = [];
        this.filterShow = false;
        let data = this.filterWhere;
        data[this.pamName] = [];
        this.$emit("update:filterWhere", data);
        this.$emit("filterConfirm", this.pamName);
        if(this.pamName == "trademarkName"){
           this.filterServiceText = "";
          this.filterService();
        }
      }
    },
    checkedApplicant(){
      if(this.jsonName === 'applicantFilter' || this.jsonName === 'trademarkFilter'){
        let checkedCount = this.crrSelect.length;
        this.isCheckAllApplicant = checkedCount === this.crrFilterJson.length;
      }
    },
    checkAllApplicant(value) {
      let arr = this.crrFilterJson;
      let ids = [];
      arr.map(item => {
        ids.push(item.headerValue);
      })
      this.crrSelect = value ? ids : [];
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
  }
};
